import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bar", "count", "form"]

  connect() {
    this.update()
  }

  checkboxTargetConnected() {
    this.update()
  }

  checkboxTargetDisconnected() {
    this.update()
  }

  toggle() {
    this.update()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this._checkboxesIn(event.target).forEach(cb => cb.checked = checked)
    this.update()
  }

  clearAll() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    this.update()
  }

  update() {
    const selected = this.checkboxTargets.filter(cb => cb.checked)
    const count = selected.length

    if (this.hasBarTarget) {
      this.barTarget.classList.toggle('is-visible', count > 0)
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = count > 0
        ? `${count} seleccionado${count !== 1 ? 's' : ''}`
        : ''
    }

    this.selectAllTargets.forEach(selectAll => {
      const scopedCheckboxes = this._checkboxesIn(selectAll)
      const scopedTotal = scopedCheckboxes.length
      const scopedCount = scopedCheckboxes.reduce((n, cb) => n + (cb.checked ? 1 : 0), 0)
      selectAll.checked = scopedCount > 0 && scopedCount === scopedTotal
      selectAll.indeterminate = scopedCount > 0 && scopedCount < scopedTotal
    })
  }

  submit(event) {
    const bulkType = event.currentTarget.dataset.actionType
    const selected = this.checkboxTargets.filter(cb => cb.checked).map(cb => cb.value)
    if (selected.length === 0) return

    const count = selected.length
    const form = this.formTarget
    form.querySelector('[name="bulk_type"]').value = bulkType

    // Remove previous ranking_ids and filter inputs
    form.querySelectorAll('[name="ranking_ids[]"], [data-filter-param]').forEach(el => el.remove())

    selected.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'ranking_ids[]'
      input.value = id
      form.appendChild(input)
    })

    // Forward the current URL's query params (filters, sort, page) so the
    // turbo_stream response re-renders the table with the same view state
    new URLSearchParams(window.location.search).forEach((value, name) => {
      if (name === 'bulk_type' || name === 'ranking_ids[]') return
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      input.dataset.filterParam = ''
      form.appendChild(input)
    })

    form.addEventListener("turbo:submit-end", (e) => {
      if (e.detail.success) this._showToast(count)
    }, { once: true })

    form.requestSubmit()
    this.clearAll()
  }

  _checkboxesIn(el) {
    const table = el.closest('table')
    return table ? this.checkboxTargets.filter(cb => table.contains(cb)) : this.checkboxTargets
  }

  _showToast(count) {
    const container = document.getElementById('toast-container')
    if (!container) return
    const id = `bulk-toast-${Date.now()}`
    const label = count === 1 ? '1 elemento procesado' : `${count} elementos procesados`
    container.insertAdjacentHTML('beforeend', `
      <div id="${id}" class="toast toast--success fade" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="true" data-bs-delay="4000">
        <div class="d-flex align-items-center">
          <div class="toast-body"><span class="toast__icon">✓</span> <span>${label}</span></div>
          <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>`)
    const el = document.getElementById(id)
    new bootstrap.Toast(el).show()
  }
}
